<template>
    <div id="reconciliationManage">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px">
                <el-select filterable v-model="searchForm.status" placeholder="请选择入账状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px">
                <el-select filterable v-model="searchForm.engineerName" placeholder="请选择工程师" clearable>
                    <el-option v-for="(item,index) in pickingEngineerList" 
                        :label="item.name" 
                        :value="item.name" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:160px;margin-bottom:15px">
                <ul class="shiftTime">
                    <li>时间筛选：</li>
                    <li :class="{'active':shiftTimeIndex == 1}" @click="shiftFuc(1)">月度</li>
                    <li :class="{'active':shiftTimeIndex == 2}" @click="shiftFuc(2)">某天</li>
                </ul>
            </el-form-item>
            <el-form-item v-if="shiftTimeIndex == 1" style="margin-bottom:15px">
                <el-date-picker
                    v-model="valueTime4"
                    type="month"
                    style="width: 100%;"
                    format="yyyy 年 MM 月"
                    value-format="yyyy-MM-dd"
                    placeholder="选择月">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-if="shiftTimeIndex == 2" style="margin-bottom:15px">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    style="width: 100%;"
                    v-model="valueTime3"
                    type="date"
                    format="yyyy 年 M 月 d 日"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button size="medium" v-if="basicsAuth.account_check_info_add" type="success" @click="newModel()">新建入账</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-card class="box-card " style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    width="140"
                    align="center"
                    prop="engineerName"                     
                    label="工程师姓名">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="sqbAr"
                    width="140"
                    label="应收款(收钱吧:元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="sqbAp"
                    width="140"
                    label="实收款(收钱吧:元)">
                </el-table-column>
                <el-table-column
                    width="140"
                    align="center"
                    prop="cashAr"
                    label="应收款(现金:元)">
                </el-table-column>
                <el-table-column
                    width="140"
                    align="center"
                    prop="cashAp"
                    label="实收款(现金:元)">
                </el-table-column>
                <el-table-column
                    width="140"
                    align="center"
                    prop="totalAr"
                    label="合计(应收:元)">
                </el-table-column>
                <el-table-column
                    width="140"
                    align="center"
                    prop="totalAp"
                    label="合计(实收:元)">
                </el-table-column>
                <el-table-column
                    width="100"
                    align="center"
                    label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '1'">无差异</span>
                        <span v-else class="active-code">有差异</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.beginTime}}~{{scope.row.endTime}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="textModelMenu[dialogModelStatus]" :visible.sync="dislogModel" :close-on-click-modal="false" width="600px" :modal-append-to-body="false"  @close="emptyModelDialog('modelForm')">
            <el-form ref="modelForm" :model="modelForm" label-width="100px" :label-position="labelPosition" :rules="modelFormRules" >
                <div>
                    <el-form-item label="工程师姓名" prop="engineerId">
                        <el-select @change="selectEnginner" v-model="modelForm.engineerName" placeholder="请选择工程师" style="width: 100%;" clearable>
                            <el-option v-for="(item,index) in pickingEngineerList" 
                                :label="item.name" 
                                :value="item.name+','+item.id" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关联工单" prop="orderNo">
                        <el-input clearable v-model.trim="modelForm.orderNo" @input="getAmountPayableData" placeholder="请输入关联工单"></el-input>
                    </el-form-item>
                    <el-form-item label="应入金额" prop="totalAr" v-if="modelForm.totalAr">
                        <el-input clearable disabled v-model.trim="modelForm.totalAr" class="yuan" placeholder="请输入应入金额"></el-input>
                    </el-form-item>
                    <el-form-item label="实入金额" prop="totalAp">
                        <el-input clearable v-model.trim="modelForm.totalAp" class="yuan" placeholder="请输入实入金额"></el-input>
                    </el-form-item>
                    <el-form-item label="入账说明" prop="desc">
                        <el-input clearable v-model.trim="modelForm.desc" placeholder="请输入入账说明"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" v-if="dialogModelStatus == 'create'" class="dialog-footer" style="text-align: center">
                <el-button type="success" @click="getOrderListData">确认</el-button>
            </span>
        </el-dialog>
        <!--分页-->
        <el-col :span="24" class="toolbar">
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pages.pageSize"
                    layout="total, sizes, prev, pager, next,jumper"
                    :total="pages.total">
                </el-pagination>
            </div>
        </el-col>
    </div>
</template>

<script>
    import { accountDayList,accountMonthlyList,accountCheckInfoAdd,engineerList,getAmountPayable,getOrderList } from "../../api/order";
     import {getPermission} from '../../api/authRequest'
    export default {
        name: 'reconciliationManage',
        data () {
            return {
                valueTime3:"",
                valueTime4:"",
                shiftTimeIndex:1,
                pickingStatusList:[
                    {
                        paraName:'无差异',
                        paraCode:'1'
                    },
                    {
                        paraName:'有差异',
                        paraCode:'2'
                    }
                ],
                pickingEngineerList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    status:"",          //入账状态
                    engineerName:'',    //工程师姓名
                    beginTime:'',       //申请开始时间
                    endTime:'',         //申请结束时间
                },
                returnData: [],
                dislogModel:false,
                dialogModelStatus: "",
                textModelMenu: {
                    update: "入账详情",
                    create: "新建入账"
                },
                modelForm:{
                    engineerName:'',
                    engineerId:'',
                    orderNo: '',
                    totalAr: '',
                    desc:'',
                    totalAp: "",
                },
                modelFormRules:{//validateRoleName
                    engineerId: [{ required: true, message: "请选择工程师", trigger: "blur" }],
                    orderNo: [{ required: true, message: "请输入关联工单", trigger: "blur" }],
                    totalAr: [{ required: true, message: "请输入应入金额", trigger: "blur" }],
                    totalAp: [{ required: true, message: "请输入入账说明", trigger: "blur" }],
                    desc: [{ required: true, message: "请输入实入金额", trigger: "blur" }]
                },
                 basicsAuth:{
                    account_check_info_add:false
                }
            }
        },
        mounted () {
            this.basicsAuth.account_check_info_add= getPermission('/api/account_check/account_check_info_add');
        },
        created(){
            this.getAccountMonthlyList();
            this.engineerListData();
        },
        methods: {
            shiftFuc(index){
                this.valueTime3 = "";
                this.valueTime4 = "";
                this.shiftTimeIndex = index;
                this.shiftTimeIndex == 1 ? this.getAccountMonthlyList() : this.getAccountDayList();
            },
            mGetDate(year, month){
                var d = new Date(year, month, 0);
                return d.getDate();
            },
            selectEnginner(e){
                this.modelForm.engineerName = e.split(",")[0];
                this.modelForm.engineerId = e.split(",")[1];
            },
            //获取工程师列表
            engineerListData(){
                engineerList({}).then(res => {
                    if (res.data.status==100) {
                        this.pickingEngineerList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取应付金额
            getAmountPayableData(){
                if(this.modelForm.orderNo.length == 17){
                    getAmountPayable({orderNo:this.modelForm.orderNo}).then(res => {
                        if (res.data.status==100) {
                            this.modelForm.totalAr = res.data.results
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }else{
                    this.modelForm.totalAr = ""
                }
            },
            //获取关联订单号
            getOrderListData(){
                getOrderList({orderNo:this.modelForm.orderNo}).then(res => {
                    if (res.data.status==100) {
                        if(res.data.results.length == 0 ){
                            this.$message({
                                message: '关联工单号错误，请重新输入',
                                type: "warning"
                            });
                        }else{
                            this.getAmountPayableData();
                            this.addModelFormSubmitBtn('modelForm');
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //关闭弹出框
            emptyModelDialog() {
                this.dislogModel = false;
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.$refs['modelForm'].resetFields();
                this.valueTime3 = "";
                this.valueTime4 = "";
                this.shiftTimeIndex = 1;
            },
            //确定新建入账
            addModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.5)'
                        });
                        this.submitNewModel();
                        loading.close();
                    }else {
                        console.log('验证未通过');
                        return false;
                    }
                    
                });
            },
            //新建提交
            submitNewModel(){
                accountCheckInfoAdd(this.modelForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: "新建成功",
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.shiftTimeIndex == 1 ? this.getAccountMonthlyList() : this.getAccountDayList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建入账
            newModel() {
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.dislogModel = true
                this.dialogModelStatus = "create";
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.shiftTimeIndex = 1;
                this.valueTime3 = "";
                this.valueTime4 = "";
                this.getAccountMonthlyList();
            },
            //获取入账管理月度列表
            getAccountMonthlyList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                accountMonthlyList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.beginTime = this.filters.formatDate(item.beginTime)
                                item.endTime = this.filters.formatDate(item.endTime)
                            })
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取入账管理某天列表
            getAccountDayList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                accountDayList(this.searchForm).then(res => {       
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.beginTime = this.filters.formatDate(item.beginTime)
                                item.endTime = this.filters.formatDate(item.endTime)
                            })
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.shiftTimeIndex == 1 ? this.getAccountMonthlyList() : this.getAccountDayList();
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.shiftTimeIndex == 1 ? this.getAccountMonthlyList() : this.getAccountDayList();
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //检索列表
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if ((this.valueTime3 == "" || this.valueTime3 == null) && (this.valueTime4 == "" || this.valueTime4 == null)) {
                            this.searchForm.beginTime = ''
                            this.searchForm.endTime = ''
                        }else{
                            if(this.shiftTimeIndex == 1){
                                if(this.valueTime4){
                                    let year = this.valueTime4.split("-")[0];
                                    let month = this.valueTime4.split("-")[1];
                                    let day = this.mGetDate(year,month);
                                    this.searchForm.beginTime = new Date(this.valueTime4+' 00:00:00');
                                    this.searchForm.endTime = new Date(year+'-'+month+'-'+day+' 23:59:59');
                                }
                            }else{
                                if(this.valueTime3){
                                    this.searchForm.beginTime = new Date(this.valueTime3+' 00:00:00');
                                    this.searchForm.endTime = new Date(this.valueTime3+' 23:59:59');
                                }
                            }
                        }
                        this.shiftTimeIndex == 1 ? this.getAccountMonthlyList() : this.getAccountDayList();
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
    #reconciliationManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .shiftTime{
            li{
                display:inline-block;
                margin-right:10px;
                font-size:14px;
                color:#666;
                margin-bottom:15px;
                cursor:pointer
            }
            li:nth-child(1){
                margin-right:5px;
                cursor:default
            }
            li.active{
                color:#409EFF
            }
        }
        .el-dialog__footer{
            text-align:center !important
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// reconciliationManage.vue?18bab7f8